import { useCoveoAnalytics } from '@gn-audio/jss-components';

import getConfig from 'temp/config';

const CoveoUserAnalytics: React.FC = () => {
  const { coveoUserAnalyticsAccessToken, coveoUserAnalyticsEndpoint } = getConfig();
  useCoveoAnalytics(coveoUserAnalyticsAccessToken, coveoUserAnalyticsEndpoint);

  return null;
};

export default CoveoUserAnalytics;
